import * as types from "../actions/actionTypes";

export function fetchGoogleBingPerformanceDataReducer(
    state = {
      message: "",
    },
    action
  ) {
    switch (action.type) {
      case types.FETCH_GOOGLE_BING_PERFORMANCE_DATA_REQUESTED:
        return Object.assign({}, state, {
          message: "FETCH_GOOGLE_BING_PERFORMANCE_DATA_REQUESTED",
        });
      case types.FETCH_GOOGLE_BING_PERFORMANCE_DATA_RECEIVED:
        let { data } = action;
        return Object.assign({}, state, {
          ...action.data,
          message: "FETCH_GOOGLE_BING_PERFORMANCE_DATA_RECEIVED",
        });
      case types.FETCH_GOOGLE_BING_PERFORMANCE_DATA_FAILED:
        return Object.assign({}, state, {
          message: "FETCH_GOOGLE_BING_PERFORMANCE_DATA_FAILED",
        });
      default:
        return state;
    }
  }
